export default {
    getMyReservationsAdditionalTableConfig: state => state.myReservationsAdditionalTableConfig,
    getMyReservationsActions: state => state.myReservationsActions,
    getMyReservationsSearchFields: state => state.myReservationsSearchFields,
    getMyReservationsTableHeaderFields: state => state.myReservationsTableHeaderFields,
    getMyReservationsRowActions: state => state.myReservationsRowActions
}
